export enum ALERT_STATUS {
    Info = "info",
    Critical = "critical",
    Warning = "warning",
    Success = "success"
}
